import React, { PureComponent } from "react";
import classnames from "classnames";

import styles from "./CollaboratorSpace.local.scss";

export class CollaboratorPerformanceFetching extends PureComponent {
  render() {
    return (
      <div>
        <div className={classnames(styles.chart_fetching, styles.gradiant)} />
        <div className={styles.frames_fetching}>
          {["1", "2", "3"].map((item, index) => (
            <div key={index} className={styles.frame}>
              <div className={classnames(styles.dot, styles.gradiant)} />
              <span className={styles.gradiant} />
              <span className={styles.gradiant} />
            </div>
          ))}
        </div>
      </div>
    );
  }
}
export class CollaboratorStatisticsFetching extends PureComponent {
  render() {
    return (
      <div>
        <div className={styles.fetching_frames}>
          {["1", "2", "3"].map(item => {
            return (
              <div className={styles.category_cellules} key={item}>
                <div className={styles.cellules_header}>
                  <div
                    className={classnames(styles.icone_frame, styles.gradiant)}
                  />
                  <span className={styles.gradiant} />
                </div>
                {["1", "2"].map(child => {
                  return (
                    <div className={styles.cellule} key={child}>
                      <div className={styles.title}>
                        <span className={styles.gradiant} />
                        <span className={styles.gradiant} />
                      </div>
                      <div className={styles.points} />
                      <div className={styles.percentage} />
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpaceLargeFrameFetching.js